import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-modelo',
  templateUrl: './text-modelo.component.html',
  styleUrls: ['./text-modelo.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextModeloComponent implements OnInit {

  get setValue(): string {
    return this.formGroup.get("equipamento").get("nmModelo").value
  }

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

}
